import React from 'react'
import IntroSections from '../IntroSections'
import S1_Fotter from '../fotter/S1_Fotter'
import intro_img from '../../img/services_intro.jpg'
import services_1 from '../../img/service-1.jpg'
import services_2 from '../../img/service-2.jpg'
import services_3 from '../../img/service-3.jpg'
import services_4 from '../../img/service-4.jpg'

const SERVICES = () => {
  return (
    <>
      <IntroSections sectionName="Services" sectionLink="Services" />
<div className='Services'>
    <div className='container'>
          <div className='Allintro'>        
    <div className='intro'>
    <h3>Services</h3>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
</div>   
    
 <img src={intro_img} alt='intro_img'/>

</div>
<div className='row All-content' >                     

    <div className='col-lg-6 '>
       <img src={services_1} alt='services'/>                  
    </div>

                      
    <div className='col-lg-6 content'>
      <h4>PHOTOSHOOT</h4>                    
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>

    </div>


    <div className='col-lg-6 content'>
      <h4>EDITING</h4>                    
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                        


    </div>

                      

    <div className='col-lg-6'>
       <img src={services_2} alt='services'/>                  
    </div>

    <div className='col-lg-6'>
       <img src={services_3} alt='services'/>                  
    </div>


    <div className='col-lg-6 content'>
      <h4>RETOUCHING</h4>                    
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                       

                          
    </div>

    <div className='col-lg-6 content'>
      <h4>LIGHTNING</h4>                    
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                      

                          
    </div>

    <div className='col-lg-6'>
       <img src={services_4} alt='services'/>                  
    </div>
           

           

</div>
</div>              
</div>

<S1_Fotter/>
    </>
  )
}

export default SERVICES